import React from "react";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  ListProps,
} from "react-admin";
import { Helmet } from "react-helmet";
import TypeField from "../../components/TypeField";
import CustomDateField from "../../components/CustomDateField";

const NotificationFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const NotificationList = (props: ListProps) => {
  return (
    <>
      <Helmet>
        <title>Notifications</title>
      </Helmet>
      <List
        exporter={false}
        filters={<NotificationFilter />}
        bulkActionButtons={false}
        sort={{ field: "CreatedAt", order: "DESC" }}
        {...props}
      >
        <Datagrid>
          <TextField source="id" />
          <TypeField source="targetType" type="notificationTarget_Type" />
          <TextField source="targetId" label="Target Id" />
          <TextField source="title" />
          <TextField source="body" />
          <CustomDateField
            source="createdAt"
            label="Created At"
            emptyText="-"
            isDateTime
          />
        </Datagrid>
      </List>
    </>
  );
};

export default NotificationList;
